import {net} from "./index";

// 查询证书信息的方法
export const getRanks = ({ pageIndex, pageSize, filter }) => {
	// 设置参数
	let params = new URLSearchParams()
	// 分页信息
	params.append('page_index', pageIndex)
	params.append('page_size', pageSize)
	// 筛选条件
	params.append('filter', JSON.stringify(filter))

	return net.request({
		params: {},
		data: params,
		method: 'post',
		url: '/admin/rank/get/list',
	})
}

// 编辑等级证书的方法
export const editRankInfo = ({ rankInfo }) => {
	// 设置参数
	let params = new URLSearchParams()
	// 证书信息
	params.append('rank_info', JSON.stringify(rankInfo))

	return net.request({
		params: {},
		data: params,
		method: 'post',
		url: '/admin/rank/edit',
	})
}

// 导入证书的方法
export const importCertificateList = ({ list, type }) => {
	// 设置参数
	let params = new URLSearchParams();
	params.append('list', JSON.stringify(list))
	return net.request({
		params: {},
		data: params,
		method: 'post',
		url: '/admin/certificate/import/'+ type,
	})
}
